// src/components/CreateAd.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import AsyncSelect from 'react-select/async';
import AdList from '../components/Adlist';            // corrige mayúscula
import './CreateAd.css';                              // opcional para estilos propios

const apiUrl = process.env.REACT_APP_API_URL || 'https://www.nualily.es';

const CreateAd = () => {
  /* --------------------- estado --------------------- */
  const [adType, setAdType]           = useState('product'); // 'product' | 'url' | 'none'
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [externalUrl, setExternalUrl] = useState('');
  const [mediaFile, setMediaFile]     = useState(null);
  const [startDate, setStartDate]     = useState('');
  const [endDate, setEndDate]         = useState('');
  const [repeatInterval, setRepeatInterval] = useState(30);
  const [loading, setLoading]         = useState(false);
  const [adId, setAdId]               = useState(null); // para editar


  /***estados para las notificaciones */
  const [notifTitle, setNotifTitle] = useState("");
const [notifBody, setNotifBody] = useState("");
const [notifUrl, setNotifUrl] = useState("/");

  /* --------------------- helpers --------------------- */

  
  const loadProducts = async (inputValue) => {
    try {
      const { data } = await axios.get(`${apiUrl}/api/products`, { params: { search: inputValue } });
      return data.map((p) => ({ label: p.name, value: p._id }));
    } catch (err) {
      console.error('Error loading products', err);
      return [];
    }
  };

  const loadAdData = async (id) => {
    try {
      const { data: ad } = await axios.get(`${apiUrl}/api/ad/${id}`);

      if (ad.productId) {
        setAdType('product');
        setSelectedProduct({ value: ad.productId, label: ad.productName || ad.productId });
      } else if (ad.externalUrl) {
        setAdType('url');
        setExternalUrl(ad.externalUrl);
      } else {
        setAdType('none');
      }

      setStartDate(ad.startDate);
      setEndDate(ad.endDate);
      setRepeatInterval(ad.repeatInterval);
    } catch (err) {
      console.error('Error loading ad data:', err);
    }
  };

  /* --------------------- submit --------------------- */
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // validaciones
    if (adType === 'product' && !selectedProduct) {
      alert('Selecciona un producto.');
      setLoading(false);
      return;
    }

    if (adType === 'url' && !externalUrl) {
      alert('Introduce una URL.');
      setLoading(false);
      return;
    }

    if (!mediaFile) {
      alert('Selecciona un archivo de medio (imagen o video).');
      setLoading(false);
      return;
    }

    const formData = new FormData();
    if (adType === 'product') formData.append('productId', selectedProduct.value);
    if (adType === 'url')     formData.append('externalUrl', externalUrl.trim());
    // si es 'none' no enviamos destino

    formData.append('startDate', new Date(startDate).toISOString());
    formData.append('endDate',   new Date(endDate).toISOString());
    formData.append('repeatInterval', repeatInterval);
    formData.append('media', mediaFile);

    try {
      if (adId) {
        await axios.put(`${apiUrl}/api/ad/${adId}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
        alert('Anuncio actualizado con éxito');
      } else {
        await axios.post(`${apiUrl}/api/ad`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
        alert('Anuncio creado con éxito');
      }
      resetForm();
    } catch (err) {
      console.error('Error al crear/editar el anuncio:', err.response?.data || err.message);
      alert(`Error: ${err.response?.data?.message || err.message}`);
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setAdType('product');
    setSelectedProduct(null);
    setExternalUrl('');
    setMediaFile(null);
    setStartDate('');
    setEndDate('');
    setRepeatInterval(30);
    setAdId(null);
  };

  /* --------------------- eliminar anuncio --------------------- */
  const handleDeleteAd = async () => {
    if (!adId) return;
    if (!window.confirm('¿Estás seguro de que quieres eliminar este anuncio?')) return;

    try {
      await axios.delete(`${apiUrl}/api/ad/${adId}`);
      alert('Anuncio eliminado con éxito');
      resetForm();
    } catch (err) {
      console.error('Error al eliminar el anuncio', err);
      alert(`Error: ${err.response ? err.response.data.message : err.message}`);
    }
  };

  /* --------------------- enviar notificación push --------------------- */
/* --------------------- notificación personalizada --------------------- */
/* --------------------- notificación personalizada --------------------- */
const handleSendNotification = async () => {
  if (!notifTitle || !notifBody) {
    alert("Escribe un título y un mensaje para la notificación");
    return;
  }

  try {
    await axios.post(
  `${apiUrl}/api/push/broadcast`,
  {
    title: notifTitle,
    body: notifBody,
    url: notifUrl || "/",
  },
  {
    headers: {
      Authorization: localStorage.getItem("token"),
    },
  }
);


    alert("🚀 Notificación enviada con éxito");
    setNotifTitle("");
    setNotifBody("");
    setNotifUrl("/");
  } catch (err) {
    console.error("❌ Error al enviar notificación:", err);
    alert("Error al enviar la notificación");
  }
};



  /* --------------------- efectos --------------------- */
  useEffect(() => { if (adId) loadAdData(adId); }, [adId]);

  /* --------------------- render --------------------- */
  return (
    <div className="create-ad-container">
      <h1>{adId ? 'Editar Anuncio' : 'Crear Anuncio'}</h1>

      <form onSubmit={handleSubmit} className="create-ad-form">
        {/* tipo de anuncio */}
        <fieldset className="ad-type-fieldset">
          <legend>Tipo de anuncio</legend>
          <label>
            <input
              type="radio"
              name="adType"
              value="product"
              checked={adType === 'product'}
              onChange={() => setAdType('product')}
            /> Producto
          </label>
          <label>
            <input
              type="radio"
              name="adType"
              value="url"
              checked={adType === 'url'}
              onChange={() => setAdType('url')}
            /> Enlace externo
          </label>
          <label>
            <input
              type="radio"
              name="adType"
              value="none"
              checked={adType === 'none'}
              onChange={() => setAdType('none')}
            /> Sin enlace
          </label>
        </fieldset>

        {/* destino: producto */}
        {adType === 'product' && (
          <>
            <label>Producto</label>
            <AsyncSelect
              cacheOptions
              defaultOptions
              loadOptions={loadProducts}
              onChange={setSelectedProduct}
              value={selectedProduct}
              placeholder="Busca y selecciona un producto"
            />
          </>
        )}

        {/* destino: url */}
        {adType === 'url' && (
          <>
            <label>URL externa</label>
            <input
              type="url"
              placeholder="https://tu-enlace.com"
              value={externalUrl}
              onChange={(e) => setExternalUrl(e.target.value)}
            />
          </>
        )}

        {/* media */}
        <label>Medio (imagen o video)</label>
        <input
          type="file"
          accept="image/*,video/*"
          onChange={(e) => setMediaFile(e.target.files[0])}
        />
        {mediaFile && (
          <div className="media-preview">
            <span>{mediaFile.name}</span>
            <button type="button" onClick={() => setMediaFile(null)}>Eliminar medio</button>
          </div>
        )}
        {loading && <p>Subiendo medio...</p>}

        {/* fechas e intervalo */}
        <label>Fecha de inicio</label>
        <input type="datetime-local" value={startDate} onChange={(e) => setStartDate(e.target.value)} />

        <label>Fecha de fin</label>
        <input type="datetime-local" value={endDate} onChange={(e) => setEndDate(e.target.value)} />

        <label>Intervalo de repetición (minutos)</label>
        <input type="number" value={repeatInterval} onChange={(e) => setRepeatInterval(e.target.value)} />

        {/* botones */}
        <button type="submit" disabled={loading}>
          {adId ? 'Actualizar anuncio' : 'Crear anuncio'}
        </button>
        {adId && (
          <button type="button" className="delete-btn" onClick={handleDeleteAd}>
            Eliminar anuncio
          </button>


          
        )}

     
        
      </form>
      {/* --------------------- sección de notificaciones push --------------------- */}
<div className="notification-section">
  <h2>Enviar notificación push</h2>

  <label>Título</label>
  <input
    type="text"
    value={notifTitle}
    onChange={(e) => setNotifTitle(e.target.value)}
    placeholder="Ej: Nueva oferta en NUA"
  />

  <label>Mensaje</label>
  <textarea
    value={notifBody}
    onChange={(e) => setNotifBody(e.target.value)}
    placeholder="Ej: Ven a ver nuestras velas con descuento especial"
  />

  <label>URL de destino (opcional)</label>
  <input
    type="url"
    value={notifUrl}
    onChange={(e) => setNotifUrl(e.target.value)}
    placeholder="https://nua.com/mi-oferta"
  />

  <button
    type="button"
    className="notify-btn"
    onClick={handleSendNotification}
  >
    🔔 Enviar notificación personalizada
  </button>
</div>


      {/* listado para editar / eliminar */}
      <AdList onEdit={setAdId} />
    </div>
  );
};

export default CreateAd;
